module.exports = __webpack_public_path__ + "img/Layer 19.b162327f.svg";